import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'common/services/core-services/authentication.service';
import { SystemService } from 'common/services/core-services/system.service';
import { LoginDataService } from 'common/services/data-services/admin/login/login-form/login-data.services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private readonly loginService: LoginDataService,
    private systemService: SystemService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isAuthenticated = this.loginService.getAuthStatus();
    console.log('isAuthenticated', isAuthenticated);
    // console.log(isAuthenticated);
    if (!isAuthenticated) {
    //  console.log('User not authenticated, redirecting to login page.');
      this.systemService.navigateToLogin(); // or this.router.navigate(['/login']);
      return false;
    }

    const allowedRoles = route.data['roles'] as string[];
    if (allowedRoles) {
      const userRole = this.systemService.getUserRole();
      if (!allowedRoles.includes(userRole)) {
        this.systemService.navigateToProfile(this.systemService.getUserType());
        return false;
      }
    }
    
    return true;
  }
}
